/**
 * @generated SignedSource<<97a41742add27bb2616c59a3ee8f5bfd>>
 * @relayHash 6a882b37f7efa3f0124a35745f7a2080
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d27410f859adf260dda4ce37c6a12e9a2b9f5e6ce63d7bceeb9ff05429eb15e6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { boardFilterRefinementQuery } from './boardFilterRefinementQuery.graphql';

import isJiraAiAgentAvatarFilterComponentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-filter-component.relayprovider';

const node: PreloadableConcreteRequest<boardFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d27410f859adf260dda4ce37c6a12e9a2b9f5e6ce63d7bceeb9ff05429eb15e6",
    "metadata": {},
    "name": "boardFilterRefinementQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarfiltercomponentrelayprovider": isJiraAiAgentAvatarFilterComponentEnabled_provider
    }
  }
};

export default node;
